import { styled as e } from "styled-components";
//#region src/components/ImageCropper/styled/ImageCropper.styled.ts
var t = e.div`
    position: relative;
    width: 100%;
    height: 360px;
    background: #1c1b1f;
    border-radius: ${({ theme: e }) => e.radii.lg};
    overflow: hidden;
`, n = e.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1.5)};
    margin-top: ${({ theme: e }) => e.spacing(2)};
    color: ${({ theme: e }) => e.colors.mutedForeground};
`, r = e.input`
    flex: 1;
    accent-color: ${({ theme: e }) => e.colors.primary};
    cursor: pointer;
`;
//#endregion
export { t as CropStage, n as ZoomRow, r as ZoomSlider };
